import { alpha, Card, Stack, styled, Typography } from "@mui/material";
import { useContext } from "react";
import palette from "src/theme/palette";
import { ActivePosition } from "src/types/products";

import Context from "../../../../context";
import CustomValueRow from "./components/CustomValueRow/CustomValueRow";
import TooltipIcons from "./components/TooltipIcons";
import ValueSelectorRow from "./components/ValueSelectorRow";

// ----------------------------------------------------------------------

const CustomCard = styled(Card)<{
	contentBackgroundColor?: string;
	type: string;
}>(({ contentBackgroundColor, type }) => {
	const shadowColor = type === "dark" ? "#000000" : palette.light.grey[500];
	return {
		backgroundColor: contentBackgroundColor,
		boxShadow: `0 0 2px 0 ${alpha(shadowColor, 0.2)}, 0 12px 24px -4px ${alpha(shadowColor, 0.12)}`
	};
});

type Props = {
	position: ActivePosition;
};

export const FundItem = ({ position }: Props) => {
	const { theme, themeType } = useContext(Context);
	const { positionId, name, owners, portfolio } = position;

	const ownersNames = owners.map((owner) => owner).join(" / ");

	const backgroundColor =
		owners.length > 1
			? alpha(theme?.colors.contentBackground ?? "", 0.2)
			: theme?.colors.contentBackground ?? "";

	return (
		<CustomCard sx={{ px: 2, py: 1.5 }} contentBackgroundColor={backgroundColor} type={themeType}>
			<Stack flexDirection={"row"} alignItems={"center"} gap={2}>
				<Typography variant='subtitle1' fontSize={16} color={theme?.colors.primaryText} noWrap>
					{name}
				</Typography>
				<TooltipIcons ownersNames={ownersNames} portfolio={portfolio} />
			</Stack>
			<ValueSelectorRow position={position} />
			<CustomValueRow id={positionId} />
		</CustomCard>
	);
};

export default FundItem;
